export const SET_DROPDOWN = 'SET_DROPDOWN';
export const SET_ABOVE = 'SET_ABOVE';
export const RESET = 'RESET';
export const FIELDS_STATE = {
    DROPDOWN: 'dropdown',
    ABOVE: 'above',
};
